const component = "programming-date-range-inputs";

export const programmingDateRangeInputs = {
  component,
  startDate: {
    label: `${component}/start-date/label`,
    datePicker: `${component}/start-date/date-picker`,
    errorText: `${component}/start-date/error-text`,
  },
  startTime: {
    label: `${component}/start-time/label`,
    datePicker: `${component}/start-time/date-picker`,
    errorText: `${component}/start-time/error-text`,
  },
  endDate: {
    label: `${component}/end-date/label`,
    datePicker: `${component}/end-date/date-picker`,
    errorText: `${component}/end-date/error-text`,
  },
  endTime: {
    label: `${component}/end-time/label`,
    datePicker: `${component}/end-time/date-picker`,
    errorText: `${component}/end-time/error-text`,
  },
  indefinitePeriodSwitch: `${component}/indefinite-period-switch`,
};
